import { profile } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'
import {
    updatePersonalInfoTypes,
    updateJobInfoTypes,
    addRevisionTypes,
} from './type'

export const getselfProfileInfo = (): Promise<any> => {
    return axios.get(profile.SELF)
}

export const getPersonalInfo = (params: Record<string, any>): Promise<any> => {
    return axios.get(profile.GETPERSONALINFO, { params })
}

export const getJobInfo = (params: Record<string, any>): Promise<any> => {
    return axios.get(profile.JOBINFO, { params })
}

export const updateJobInfo = (body: updateJobInfoTypes): Promise<any> => {
    return axios.put(profile.UPDATEJOBINFO, body)
}

export const updatePersonalInfo = (
    body: updatePersonalInfoTypes
): Promise<any> => {
    return axios.put(profile.UPDATEPERSONALINFO, body)
}

export const getFormsCompleted = (
    params: Record<string, any>
): Promise<any> => {
    return axios.get(profile.GETFORMSCOMPLETED, { params })
}

export const getTrainingCompleted = (
    params: Record<string, any>
): Promise<any> => {
    return axios.get(profile.GETTRAININGCOMPLETED, { params })
}

export const getUserStats = (params: Record<string, any>): Promise<any> => {
    return axios.get(profile.GETUSERSTATS, { params })
}

export const addRevision = (body: addRevisionTypes): Promise<any> => {
    return axios.post(profile.ADDREVISION, body)
}

export const timeOffSearch = (body: any): Promise<any> => {
    return axios.post(profile.TIMEOFFSEARCH, body)
}

export const editLeavePolicy = (
    userId: string,
    leavePolicyId: string
): Promise<any> => {
    const url = `${profile.LEAVEPOLICYEDIT}?userId=${userId}&leavePolicyId=${leavePolicyId}`
    return axios.put(url)
}

export const getAllStates = (): Promise<any> => {
    return axios.post(profile.GETALLSTATES)
}
